import authHeader from './auth-header';
import Api from './api';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class EdiaryReportSelectionService {
	
  async getById(responseSelectionId: number) {
	return await Api().get(`${API_URL}/ediaryReportSelection/${responseSelectionId}`, { headers:  authHeader() as any });      
  }
  async find() {
    return await Api().get(`${API_URL}/ediaryReportSelection/find`, { headers:  authHeader() as any });      
  }

  async updateReportDownloadSelection(responseSelection: any) {
    return await Api().put(`${API_URL}/ediaryReportSelection/${responseSelection.id}`, responseSelection, 
    { method: 'PUT',
      headers:  authHeader() as any });      
  }

  async createReportDownloadSelection(responseSelection: any) {
    return await Api().post(`${API_URL}/ediaryReportSelection/`, responseSelection, 
    { method: 'POST',
      headers:  authHeader() as any });      
  }

  async deleteReportDownloadSelection(responseSelection: any) {
    return await Api().delete(`${API_URL}/ediaryReportSelection/${responseSelection.id}`, 
    { method: 'DELETE',
      headers:  authHeader() as any });      
  }
}

export default new EdiaryReportSelectionService();